var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"share-this"},[_c('div',{staticClass:"sharethis-inline-share-buttons",attrs:{"data-url":_vm.url,"data-title":"Link da sua cotação de plano de saúde"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }